import {HttpRequest} from '../../../settings/HttpRequest/HttpRequest';
import {DateFormat} from "../../../settings/DateFormat/DateFormat";

export const NominaService = {
	Listar: (filtro, paginacion) => {
		let fecha_inicio = (filtro.fecha_solicitud_inicio || null) ? DateFormat.FormatSql(filtro.fecha_solicitud_inicio) : null;
		let fecha_fin = (filtro.fecha_solicitud_fin || null) ? DateFormat.FormatSql(filtro.fecha_solicitud_fin) : null;
		let params = {
			filtro: {
				no_recibo: filtro.no_recibo || null,
				usuario: filtro.usuario || null,
				proyecto: filtro.proyecto || null,
				id_cat_area_proyecto: filtro.id_cat_area_proyecto || null,
				id_cat_estatus_nomina: filtro.id_cat_estatus_nomina || null,
				fecha_solicitud_inicio: fecha_inicio,
				fecha_solicitud_fin: fecha_fin,
				activo: (Number(filtro.activo) === 1 || Number(filtro.activo) === 0) ? Number(filtro.activo) : null,
			},
			paginacion: {
				total: paginacion.total || null,
				page: paginacion.page || null,
				limit: paginacion.limit || null
			}
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Nomina_Datos', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	Agregar: (form) => {
		
		let params = {
			id_nomina: null,
			no_recibo: form.no_recibo || '',
			id_usuario: form.id_usuario || '',
			descripcion_general: form.descripcion_general || '',
			id_cat_clasificacion_pago: form.id_cat_clasificacion_pago || '',
			id_proveedor: form.id_proveedor || '',
			id_cuenta_bancaria: form.id_cuenta_bancaria || '',
			beneficiario: form.beneficiario || '',
			banco: form.banco || '',
			numero_tarjeta: form.numero_tarjeta || '',
			id_cat_area_proyecto: form.id_cat_area_proyecto || '',
			id_cat_etapa_proyecto: form.id_cat_etapa_proyecto || '',
			id_cat_subetapa_proyecto: form.id_cat_subetapa_proyecto || '',
			id_cat_clase: form.id_cat_clase || '',
			id_cat_subclase: form.id_cat_subclase || '',
			id_cat_banco: form.id_cat_banco || '',
			id_cat_tipo_cuenta: form.id_cat_tipo_cuenta || '',
			id_cat_empresa: form.id_cat_empresa || '',
			id_cat_tipo_pago: form.id_cat_tipo_pago || '',
			observaciones: form.observaciones || '',
			partidas: form.partidas || [],
			activo: form.activo ? 1 : 0,
			
			archivo: form.archivo,
			archivo_formato: form.archivo_formato,
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Nomina_Guardar', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	Modificar: (form) => {
		let params = {
			id_nomina: form.id_nomina,
			no_recibo: form.no_recibo || '',
			descripcion_general: form.descripcion_general || '',
			id_usuario: form.id_usuario || '',
			id_cat_clasificacion_pago: form.id_cat_clasificacion_pago || '',
			id_proveedor: form.id_proveedor || '',
			id_cuenta_bancaria: form.id_cuenta_bancaria || '',
			beneficiario: form.beneficiario || '',
			banco: form.banco || '',
			numero_tarjeta: form.numero_tarjeta || '',
			id_cat_area_proyecto: form.id_cat_area_proyecto || '',
			id_cat_etapa_proyecto: form.id_cat_etapa_proyecto || '',
			id_cat_subetapa_proyecto: form.id_cat_subetapa_proyecto || '',
			id_cat_clase: form.id_cat_clase || '',
			id_cat_subclase: form.id_cat_subclase || '',
			id_cat_banco: form.id_cat_banco || '',
			id_cat_tipo_cuenta: form.id_cat_tipo_cuenta || '',
			id_cat_tipo_pago: form.id_cat_tipo_pago || '',
			id_cat_empresa: form.id_cat_empresa || '',
			observaciones: form.observaciones || '',
			partidas: form.partidas || [],
			activo: form.activo ? 1 : 0,
			
			archivo: form.archivo,
			archivo_formato: form.archivo_formato,
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Nomina_Modificar', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	Eliminar: (id_nomina) => {
		let params = {
			id_nomina: id_nomina
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Nomina_Eliminar', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	NoRecibo: () => {
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Nomina_NoRecibo', {}).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	EstatusAgregar: (form) => {
		let params = {
			id_nomina: form.id_nomina,
			id_cat_estatus_nomina: form.id_cat_estatus_nomina,
			id_usuario: form.id_usuario ?? null,
			comentarios: form.comentarios ?? null,
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Nomina_Estatus', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	Comprobante: (form) => {
		let fecha_pago = form.fecha_pago ? DateFormat.FormatSql(form.fecha_pago) : '';
		let params = {
			id_nomina: form.id_nomina,
			id_cat_estatus_nomina: form.id_cat_estatus_nomina,
			fecha_pago: fecha_pago,
			monto: form.monto,
			comentarios: form.comentarios,
			archivo: form.archivo,
			archivo_formato: form.archivo_formato,
			tipo_comprobante: form.tipo_comprobante
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Nomina_Comprobante', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	EliminarComprobante: (id_nomina_comprobante) => {
		let params = {
			id_nomina_comprobante: id_nomina_comprobante
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Nomina_Eliminar_Comprobante', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
};
